import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { addisLoading, addservices } from "../../utils/redux/mainSlice";
import { getServices } from "../../utils/apis/func";
import { RootState } from "../../utils/redux/store";

interface Service {
  id: string;
  name: string;
}

const NewPromoCode = () => {
  const [promoCode, setPromoCode] = useState<string>("");
  const [percentageDiscount, setPercentageDiscount] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    setSearchQuery("");
    setSelectedAllServices([]);
    setIsFocused(false);
  };

  // fix start here
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetchServices = async () => {
      dispatch(addisLoading(true));
      const res: any = await getServices("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addservices(res?.data?.services));
      }
      dispatch(addisLoading(false));
    };
    fetchServices();
  }, [dispatch]);
  const allServices = useAppSelector((store: RootState) => store.user.services);

  const allServicesFiltered = searchQuery.trim()
    ? allServices.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
      )
    : allServices;

  const [selectedAllServices, setSelectedAllServices] = useState<string[]>([]);

  const handleCheck = (service: any) => {
    setSelectedAllServices((prevSelected) => {
      const isSelected = prevSelected.some(
        (item: any) => item._id === service._id
      );
      if (isSelected) {
        return prevSelected.filter((item: any) => item._id !== service._id);
      } else {
        return [...prevSelected, service];
      }
    });
  };

  const handleSelectAllService = () => {
    if (selectedAllServices.length === allServicesFiltered.length) {
      setSelectedAllServices([]);
    } else {
      setSelectedAllServices(allServicesFiltered);
    }
  };

  const handleCreatePromoCode = async () => {
    dispatch(addisLoading(true));
    const AuthToken = await localStorage.getItem("AuthToken");
    const promoPayload = {
      code: promoCode,
      applyToAllServices:
        selectedAllServices === allServicesFiltered ? true : false,
      percentageDiscount: parseFloat(percentageDiscount),
      services: selectedAllServices.map((item: any) => item?._id),
    };

    try {
      const response = await axios.post(
        "https://api.pureworker.com/api/admin/promo",
        promoPayload,
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Promo code saved successfully!");
        setPromoCode("");
        setSelectedAllServices([]);
        setPercentageDiscount("");
        handleCancel();
      } else {
        toast.error("Failed to save promo code. Please try again.");
      }
    } catch (error) {
      console.error("Error saving promo code:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      dispatch(addisLoading(false));
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-8">
      <div className="flex justify-between items-center mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-purple-600 hover:underline"
        >
          Back
        </button>
        <h2 className="text-2xl font-semibold">Create New Promo Code</h2>
      </div>
      <div className="mb-4">
        <label htmlFor="code" className="block font-medium mb-1">
          Code
        </label>
        <input
          type="text"
          id="code"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          placeholder="Enter promo code"
          className="w-full border border-gray-300 rounded p-2"
        />
      </div>

      {/* fix here  */}
      <div className="mb-4">
        <label htmlFor="services" className="block font-medium mb-1">
          Services
        </label>
        <div className="border border-gray-300 rounded p-2">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onFocus={() => setIsFocused(true)}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border-b mb-2"
          />

          {isFocused && (
            <>
              <div className="overflow-y-auto max-h-64">
                {allServicesFiltered.map((service) => (
                  <div key={service.id} className="flex items-center p-2">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={selectedAllServices.some(
                        (item: any) => item._id === service._id
                      )}
                      onChange={() => handleCheck(service)}
                    />
                    <label>{service.name}</label>
                  </div>
                ))}
              </div>
              <div className="flex justify-between mt-4">
                <button
                  onClick={handleSelectAllService}
                  className="text-purple-600 hover:underline"
                >
                  {selectedAllServices?.length === allServicesFiltered.length
                    ? "Unselect All"
                    : "Select All"}
                </button>
                <button
                  onClick={handleCancel}
                  className="text-white bg-[#88087B] py-2 px-4 rounded"
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="mb-6">
        <label htmlFor="discount" className="block font-medium mb-1">
          Discount (%)
        </label>
        <input
          type="text"
          id="discount"
          value={percentageDiscount}
          onChange={(e) => setPercentageDiscount(e.target.value)}
          placeholder="Enter discount percentage"
          className="w-full border border-gray-300 rounded p-2"
        />
      </div>
      <button
        className="w-full bg-[#88087B] text-white py-2 rounded"
        onClick={handleCreatePromoCode}
      >
        Save
      </button>
    </div>
  );
};

export default NewPromoCode;
